/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GEPContributorViewModel
 */
export interface GEPContributorViewModel {
    /**
     * 
     * @type {string}
     * @memberof GEPContributorViewModel
     */
    employerSchemeName?: string;
    /**
     * 
     * @type {string}
     * @memberof GEPContributorViewModel
     */
    employeeNumber?: string;
}

/**
 * Check if a given object implements the GEPContributorViewModel interface.
 */
export function instanceOfGEPContributorViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GEPContributorViewModelFromJSON(json: any): GEPContributorViewModel {
    return GEPContributorViewModelFromJSONTyped(json, false);
}

export function GEPContributorViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): GEPContributorViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'employerSchemeName': !exists(json, 'EmployerSchemeName') ? undefined : json['EmployerSchemeName'],
        'employeeNumber': !exists(json, 'EmployeeNumber') ? undefined : json['EmployeeNumber'],
    };
}

export function GEPContributorViewModelToJSON(value?: GEPContributorViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'EmployerSchemeName': value.employerSchemeName,
        'EmployeeNumber': value.employeeNumber,
    };
}

